import React from "react";
import Section1TopBanner from "../../components/Home/Section1TopBanner";
import Section2VehicleSlider from "../../components/Home/Section2VehicleSlider";
import Section3BecomeHelper from "../../components/Home/Section3BecomeHelper";
import Section4CompanyInfo from "../../components/Home/Section4CompanyInfo";
import Section5WhyMoovez from "../../components/Home/Section5WhyMoovez";
import Section6HowItWorks from "../../components/Home/Section6HowItWorks";
import Section7Benifits from "../../components/Home/Section7Benifits";
import Section8FAQs from "../../components/Home/Section8FAQs";

const Home = () => {
  return (
    <div>
      <Section1TopBanner />
      <Section2VehicleSlider />
      <Section3BecomeHelper />
      <Section4CompanyInfo />
      <Section5WhyMoovez />
      <Section6HowItWorks />
      <Section7Benifits />
      <Section8FAQs />
    </div>
  );
};

export default Home;
